module.exports = __webpack_public_path__ + "af93e38607c4e2628f54e8d26f72c174.svg";